<template>
    <b-navbar toggleable="lg" type="dark" variant="primary" class="mb-3">
        <b-navbar-brand to="/">
            Raum + Schrift
        </b-navbar-brand>

        <b-navbar-toggle target="nav-collapse" />

        <b-collapse id="nav-collapse" is-nav>
            <b-navbar-nav v-if="isAuthenticated">
                <b-nav-item :to="{ name: 'projects.index' }">
                    {{ $t('Projects') }}
                </b-nav-item>

                <b-nav-item
                    v-if="$auth.check(USER_ROLES.ADMIN)"
                    :to="{ name: 'users.index' }"
                >
                    {{ $t('Users') }}
                </b-nav-item>

                <b-nav-item
                    v-if="$gate.allow('viewAny', 'group')"
                    :to="{ name: 'groups.index' }"
                >
                    {{ $t('Groups') }}
                </b-nav-item>

                <b-nav-item
                    v-if="$auth.check(USER_ROLES.ADMIN)"
                    :to="{ name: 'staff_members.index' }"
                >
                    {{ $t('Staff members') }}
                </b-nav-item>

                <b-nav-item
                    v-if="$auth.check(USER_ROLES.ADMIN)"
                    :to="{ name: 'customers.index' }"
                >
                    {{ $t('Customers') }}
                </b-nav-item>

                <b-nav-item
                    v-if="$auth.check([USER_ROLES.ADMIN, USER_ROLES.USER])"
                    :to="{ name: 'foundations.index' }"
                >
                    {{ $t('Foundations') }}
                </b-nav-item>

                <b-nav-item
                    v-if="$gate.allow('viewAny', 'address')"
                    :to="{ name: 'addresses.index' }"
                >
                    {{ $t('Addresses') }}
                </b-nav-item>

                <b-nav-item
                    v-if="$gate.allow('viewAny', 'disability')"
                    :to="{ name: 'disabilities.index' }"
                >
                    {{ $t('Disabilities') }}
                </b-nav-item>
            </b-navbar-nav>

            <!-- Right aligned nav items -->
            <b-navbar-nav class="ml-auto">
                <template v-if="isAuthenticated">
                    <issues-nav-item/>

                    <b-nav-item-dropdown right>
                        <!-- Using 'button-content' slot -->
                        <template slot="button-content">
                            <em>{{ $auth.user().name }}</em>
                        </template>
                        <b-dropdown-item @click="$auth.logout()">
                            {{ $t('Logout') }}
                        </b-dropdown-item>
                    </b-nav-item-dropdown>
                </template>

                <b-dropdown-item v-else :to="{ name: 'login' }">
                    {{ $t('Login') }}
                </b-dropdown-item>
            </b-navbar-nav>
        </b-collapse>
    </b-navbar>
</template>

<script>
    import {USER_ROLES} from '@/constants'
    import IssuesNavItem from "@/components/layout/IssuesNavItem";

    export default {
    name: 'HeaderNavigation',
    components: {IssuesNavItem},
    data() {
        return {
            USER_ROLES
        }
    }
}
</script>
